











































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import LendingTermSettings from '@/models/Products/ProductSettings/DefaultSettings/Term/LendingTermSettings';
import LendingTermSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/Term/LendingTermSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'LendingTermSettingsRead', components: { ProductState, LendingTermSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: LendingTermSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }
}
